import { events } from '~features/annals';
import { useSendEvent } from '~features/annals/useSendEvent';

export const useRetentionPopupShown = () =>
	useSendEvent(events.retention.popupShown);

export const useRetentionPopupCTAClicked = () =>
	useSendEvent(events.retention.popupCTAClicked);
